module.exports = ":host {\n  height: calc(100% - 52px - 30px); }\n\n.eNewsParagraph {\n  font-weight: 400;\n  text-align: center;\n  font-size: 0.9rem; }\n"